// Angular
import { Component, Input, OnChanges } from '@angular/core';

// Afidium
import { ISectorAir } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { ILabels } from 'libraries/interfaces/ILabels';
import { Yii } from 'libraries/interfaces/Yii';
import { DatesService } from 'app_sasha/shared/services/dates/dates.service';

@Component({
    selector: 'travel-date',
    template: `
        <span *ngIf="sector.begin" class="begin-date">
            <ng-container *ngIf="isNotTheSameDate">{{ labels.from }} </ng-container>
            <strong>{{ dates.begin }}</strong>
        </span>

        <span *ngIf="sector.end && isNotTheSameDate" class="end-date">{{ labels.to }} <strong>{{ dates.end }}</strong></span>

        <em *ngIf="sector.duration" class="duration">({{ sector.duration.minute | duration }})</em>
    `,
})
export class TravelDateComponent implements OnChanges {
    @Input()
    public sector: ISectorAir;

    public dates: {
        begin: string;
        end: string;
    };

    public labels: ILabels = {
        from: Yii.t('wui-sasha-js', 'Du'),
        to: Yii.t('wui-sasha-js', 'au'),
    };

    public isNotTheSameDate: boolean;

    constructor(
        private readonly datesService: DatesService
    ) {
    }

    public ngOnChanges(): void {
        this.dates = {
            begin: this.datesService.formatDate(this.sector.begin, 'LL'),
            end: this.datesService.formatDate(this.sector.end, 'LL'),
        };
        this.isNotTheSameDate = this.computeIsNotTheSameDate();
    }

    public computeIsNotTheSameDate(): boolean {
        const begin: Date = new Date(this.dates.begin);
        const end: Date = new Date(this.dates.end);
        return begin.toDateString() !== end.toDateString();
    }
}
